import { render, staticRenderFns } from "./heaerbutom.vue?vue&type=template&id=6aa81a1c&scoped=true&"
import script from "./heaerbutom.vue?vue&type=script&lang=js&"
export * from "./heaerbutom.vue?vue&type=script&lang=js&"
import style0 from "./heaerbutom.vue?vue&type=style&index=0&id=6aa81a1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa81a1c",
  null
  
)

export default component.exports